import React from 'react';
import ReactDOM from 'react-dom/client';
import { RoutingLoader } from './routing/RoutingLoader';
import '@iress-oss/ids-components/dist/style.css';
import '@iress/themes/build/css/iress-theme-light.css';
import '@iress/themes/build/css/iress-beta-theme-light.css';
import '@iress/themes/global.css';
import { QueryClientLoader } from './components';
import { IressModalProvider, IressToasterProvider, IressSlideoutProvider } from '@iress-oss/ids-components';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <div className="uk-wealth-theme iress-beta-theme-light">
            <IressToasterProvider>
                <IressModalProvider>
                    <IressSlideoutProvider>
                        <QueryClientLoader>
                            <RoutingLoader />
                        </QueryClientLoader>
                    </IressSlideoutProvider>
                </IressModalProvider>
            </IressToasterProvider>
        </div>
    </React.StrictMode>
);
